/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-07 14:05:30
 *
 *******************************************************/
// @flow
//
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Button, TextStyle, Select } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import ProcessAddon from './process-addon';
import { buildAnalyticsInstance } from 'src/helpers/subscription-v3-helper';
import { mixpanelV3Helper } from 'src/helpers/mixpanel-v3';
import { allowToShowBFCM23 } from 'src/helpers/dashboard-helper';
import analyticsCardBFCM23 from 'src/assets/images/common/analytic-add-on.png';
import offer50AnalyticBFCM23 from 'src/assets/images/common/bfcm23-50.png';
import StarsIcon from 'src/assets/images/common/stars-2x.svg';

type State = {
  openModalReview: boolean,
  // Store analytic addon
  analyticList: Array<any>,
  analytic: string,
  firstLoad: boolean
};

class AddonCard extends Component<WithI18nProps, State> {
  state = {
    openModalReview: false,
    // Store analytic addon
    analyticList: [],
    analytic: '90',
    firstLoad: true
  };

  componentWillMount() {
    const { analyticDays } = this.props;
    if (analyticDays) this.setState({ analytic: analyticDays });
  }

  componentDidMount() {
    if (this.props.selected) this.setState({ openModalReview: true });
  }

  componentWillReceiveProps(nextProps) {
    const { gettingInvoice: gettingInvoicePrev, addon: addonPrev, analyticDays } = this.props;
    const { invoiceSubscribed, getInvoiceSuccess, gettingInvoice, addon } = nextProps;

    // Init value analytics and
    if (
      ((getInvoiceSuccess === true && gettingInvoice === false && gettingInvoicePrev === true) ||
        addonPrev !== addon) &&
      addon.name === 'analytics'
    ) {
      const analyticList = buildAnalyticsInstance(addon, invoiceSubscribed);

      this.setState({
        analyticList,
        analytic:
          analyticList.length > 0 ? (analyticDays ? analyticDays : analyticList[0].value) : '365'
      });
    }
  }
  render() {
    const { openModalReview, analyticList, analytic } = this.state;
    const {
      i18n,
      addon = {},
      gettingInvoice,
      statusStore,
      notAllowAddon,
      handleAfterSubscribeAddon,
      tenantApp
    } = this.props;
    const { title, description, descriptionBackup, price, status, name, image } = addon;
    // Option available of analytic
    const options = analyticList.map(e => ({
      value: e.value,
      label: i18n.translate(e.label).toLowerCase()
    }));

    const analyticPrice = analyticList.find(e => e.value === analytic)?.price;
    const buttonContent = i18n.translate(
      `AdminHTML.SubscriptionV3.Actions.${
        !['trial', 'expiredSoon'].includes(statusStore) && status === 'addToTrial'
          ? 'startTrial'
          : status
      }`
    );
    const bfcm23 = allowToShowBFCM23(tenantApp);
    const isBFCM23Addon = bfcm23.allow && bfcm23.type === 'professional365' && name === 'analytics';

    return (
      <>
        <Card portrait>
          <img
            alt=""
            width="100%"
            height="auto"
            style={{ objectFit: 'cover', objectPosition: 'center' }}
            src={isBFCM23Addon ? analyticsCardBFCM23 : image}
          />
          <div className={`addon-card-detail ${isBFCM23Addon && 'bfcm23-add-on-highlight'}`}>
            {isBFCM23Addon && <img src={offer50AnalyticBFCM23} alt="offer" className="offer-50" />}
            <TextStyle variation="strong">{i18n.translate(title)}</TextStyle>
            <div className="addon-price">
              <span>
                {i18n.translate('AdminHTML.SubscriptionV3.Common.pricePerMonth', {
                  price: name === 'analytics' ? analyticPrice : price
                })}
              </span>
              {name === 'analytics' && !gettingInvoice && (
                <Select
                  disabled={status === 'added'}
                  value={analytic}
                  onChange={this.handleChangeAnalytic}
                  options={options}
                />
              )}
            </div>
            <div style={{ marginTop: '8px', lineHeight: '20px' }}>
              {name === 'analytics'
                ? i18n.translate(descriptionBackup)
                : i18n.translate(description)}
            </div>
            {isBFCM23Addon ? (
              <Button
                disabled={status === 'added' || notAllowAddon}
                onClick={() => {
                  this.toggleModal('openModalReview');
                  mixpanelV3Helper.trackOpenSubscriptionReview(
                    mixpanelV3Helper.getMappingAddOnName()[name],
                    window.location.pathname,
                    i18n.translate(
                      'AdminHTML.Dashboard.SubscriptionStatus.BFCM2023_Discount_Percent_text3'
                    )
                  );
                  mixpanelV3Helper.trackEventData('Click on Add-on adding button', {
                    path: window.location.pathname,
                    buttonText: i18n.translate(
                      'AdminHTML.Dashboard.SubscriptionStatus.BFCM2023_Discount_Percent_text3'
                    )
                  });
                }}>
                <img src={StarsIcon} alt="stars" style={{ marginRight: '4px' }} />
                {i18n.translate(
                  'AdminHTML.Dashboard.SubscriptionStatus.BFCM2023_Discount_Percent_text3'
                )}
              </Button>
            ) : (
              <Button
                disabled={status === 'added' || notAllowAddon}
                onClick={() => {
                  this.toggleModal('openModalReview');
                  mixpanelV3Helper.trackOpenSubscriptionReview(
                    mixpanelV3Helper.getMappingAddOnName()[name],
                    window.location.pathname,
                    buttonContent
                  );
                }}>
                {buttonContent}
              </Button>
            )}
          </div>
        </Card>
        <ProcessAddon
          openModalReview={openModalReview}
          addon={addon}
          handleAfterSubscribeAddon={handleAfterSubscribeAddon}
          handleReviewModal={() => this.toggleModal('openModalReview')}
          analytic={analytic}
        />
      </>
    );
  }

  // Toggle modal
  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  // Handle change analytic add on
  handleChangeAnalytic = value => {
    this.setState({ analytic: value });
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const invoiceSubscribed = _.get(state.subscriptionV3, 'invoice', {});
  return {
    invoiceSubscribed,
    tenantApp,
    statusStore: _.get(state.oauth, 'subscription.status', ''),
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', ''),
    gettingInvoice: _.get(state.subscriptionV3, 'gettingInvoice', false),
    getInvoiceSuccess: _.get(state.subscriptionV3, 'getInvoiceSuccess', false)
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(AddonCard));
